import React, { useEffect, useRef } from "react";
import { default as SVG } from "react-inlinesvg";
import DOMPurify from "dompurify";
import VintomLogo from "../../../../assets/images/vintom-logo.svg?raw";

interface Props {
  className?: string;
  src?: string;
  href?: string;
}

export const LogoComponent: React.FC<Props> = ({ className, src, href }) => {
  const [srcMime, setSrcMime] = React.useState<null | "svg" | "img">(src == null ? "svg" : null);
  const [srcData, setSrcData] = React.useState<null | string>(null);

  const svgRef = useRef<SVGSVGElement | null>(null);

  const isLink = href != null;

  useEffect(() => {
    setSrcMime(null);
    setSrcData(null);

    // Download logo data
    if (!src) {
      return;
    }

    fetch(src).then(async (response) => {
      const contentType = response.headers.get("Content-Type") === "image/svg+xml" ? "svg" : "img";

      if (contentType === "svg") {
        setSrcData(await response.text());
      }

      setSrcMime(contentType);
    });
  }, [src]);

  const makeSvgResponsive = (svgElement: SVGSVGElement) => {
    const bbox = svgElement.getBBox();
    const aspectRatio = bbox.width / bbox.height;

    svgElement.setAttribute("viewBox", `${bbox.x} ${bbox.y} ${bbox.width} ${bbox.height}`);
    svgElement.style.setProperty("aspect-ratio", String(aspectRatio));
  };

  const Component = isLink ? "a" : "div";

  const props = isLink
    ? {
        href,
        target: "_blank",
      }
    : {};

  return (
    <Component className={`${className || ""}`} {...props}>
      {(srcMime === "svg" || src == null) && (
        <SVG
          src={srcData ?? VintomLogo}
          innerRef={svgRef}
          preProcessor={(svg) => DOMPurify.sanitize(svg)}
          onLoad={() => makeSvgResponsive(svgRef.current!)}
        />
      )}

      {srcMime === "img" && <img src={src} alt="Logo" />}
    </Component>
  );
};

LogoComponent.displayName = "DesktopLogoComponent";
